import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AbstractFormComponent } from '../../../../../shared/crud/component/form.component';
import { AdminUrlBuilder } from '../../../../../shared/admin/api/admin-url-builder';
import { WebsiteRedirectAddForm } from './website-redirect-add.form';

@Component({
  selector: 'add-website-redirect-form',
  templateUrl: './form-add.component.html',
  styleUrls: [ './form-add.component.scss' ],
})
export class WebsiteRedirectAddFormComponent extends AbstractFormComponent implements OnInit, AfterViewInit {

  @Input() channel: Subject<any>;


  constructor(formBuilder: WebsiteRedirectAddForm,
              httpClient: HttpClient,
              toastrService: ToastrService,
              urlBuilder: AdminUrlBuilder,
              router: Router,
              route: ActivatedRoute) {
    super(formBuilder, httpClient, toastrService, router, route, urlBuilder);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.formMode = 'create';
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();

    if (this.formMode === 'update') {
      this.populate().subscribe();
    }
  }

  protected getUrl(): string {
    const params = this.route.snapshot.params;
    return '/website-redirect' + (params.id ? '/' + params.id : '');
  }

  protected onSubmit(response: any): void {
    this.toastrService.success('Saved');
    this.channel.next(this.record);
    this.record = {};
    this.form.reset();
  }

  submit(): void {
    this.formMode = 'create';
    super.submit();
  }
}
